export const socialLinks = {
    telegram: 'https://t.me/tcodeworld',
    vk: 'https://vk.com/true.code',
    behance: 'https://www.behance.net/tcode',
    dzen: 'https://dzen.ru/truecode',
    instagram: 'https://www.instagram.com/true.code',
    vc: 'https://vc.ru/id348218',
}